import {Repository} from '@s-ui/domain'

export default class FetcherRepository extends Repository {
  getAuthenticationToken() {
    throw new Error('[FetcherRepository#getAuthenticationToken] must be implemented')
  }

  setAuthenticationToken() {
    throw new Error('[FetcherRepository#setAuthenticationToken] must be implemented')
  }

  removeAuthenticationToken() {
    throw new Error('[FetcherRepository#removeAuthenticationToken] must be implemented')
  }
}
